import React from "react";
import { KpiDashboard } from "./KpiDashboard/KpiDashboard";
import { FinanceTracker } from "./FinanceTracker/FinanceTracker";
import { DataImport } from "./DataImport/DataImport";
import { ShoppingCart } from "./ShoppingCart/ShoppingCart";

export type ProjectSectionId = "business" | "playground";

export interface ProjectSection {
    id: ProjectSectionId;
    title: string;
    description: string;
}

// Shown on the Projects page in this order
export const SECTIONS: ProjectSection[] = [
    {
        id: "business",
        title: "Business tools",
        description: "Practical apps for running a business: metrics, money and data.",
    },
    {
        id: "playground",
        title: "Playground",
        description: "Smaller experiments and UI ideas we like to try out.",
    },
];

export interface ProjectInfo {
    slug: string;
    section: ProjectSectionId;
    title: string;
    tagline: string;
    description: string;
    image: string;
    tags: string[];
    accent: string;
    component: React.ComponentType;
}

export const PROJECTS: ProjectInfo[] = [
    {
        slug: "kpi-dashboard",
        section: "business",
        title: "KPI Dashboard",
        tagline: "Customisable business metrics at a glance",
        description:
            "Pick the KPIs that matter, switch between line, bar and target views, resize and reorder cards, and compare periods. Your layout is remembered.",
        image: "/images/projects/kpi-dashboard.svg",
        tags: ["Dashboard", "SVG charts", "Customisable"],
        accent: "#6d28d9",
        component: KpiDashboard,
    },
    {
        slug: "finance-tracker",
        section: "business",
        title: "Finance Tracker",
        tagline: "Income, spending and budgets in one place",
        description:
            "Log income and expenses, see where your money goes by category, compare months and set budgets that warn you before you overspend. Export everything to CSV.",
        image: "/images/projects/finance-tracker.svg",
        tags: ["Finance", "SVG charts", "Budgets"],
        accent: "#0ea5e9",
        component: FinanceTracker,
    },
    {
        slug: "data-import",
        section: "business",
        title: "Data Import",
        tagline: "Import items and orders from CSV",
        description:
            "Upload or paste a CSV, map columns automatically, validate every row and import items and orders with create-or-update logic.",
        image: "/images/projects/data-import.svg",
        tags: ["Integration", "CSV", "Validation"],
        accent: "#10b981",
        component: DataImport,
    },
    {
        slug: "shopping-cart",
        section: "playground",
        title: "Shopping Cart",
        tagline: "A clean product list with a live cart",
        description:
            "Browse 10 products, filter by category, adjust quantities and apply promo codes. Totals, VAT and free-shipping progress update instantly.",
        image: "/images/projects/shopping-cart.svg",
        tags: ["E-commerce", "State", "Promo codes"],
        accent: "#ec4899",
        component: ShoppingCart,
    },
];
